import { render, staticRenderFns } from "./TicketAttachmentsField.vue?vue&type=template&id=6f19fa73&scoped=true"
import script from "./TicketAttachmentsField.vue?vue&type=script&lang=js"
export * from "./TicketAttachmentsField.vue?vue&type=script&lang=js"
import style0 from "./TicketAttachmentsField.vue?vue&type=style&index=0&id=6f19fa73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f19fa73",
  null
  
)

export default component.exports